import React, { useCallback, useEffect } from 'react'
//@ts-ignore
import Files from 'react-butterfiles'
import {
  Button,
  Icon,
  Progress,
  Card,
  Popup,
  Statistic,
} from 'semantic-ui-react'
import TruncateString from 'react-truncate-string'
import filesize from 'filesize'
import TimeAgo from 'react-timeago'
import { cancelFunctions } from '../../utils/helpers'
import NewFolder from './NewFolderButton'
import { useDropzone } from 'react-dropzone'
import { observer, useStore } from '../../stores'
import { UploadFile } from '../../utils/models'
import { useTranslation } from 'react-i18next'

const Uploads = observer(() => {
  const { fileStore, uiStore } = useStore()
  const { t } = useTranslation()

  useEffect(() => {
    fileStore.fetch()
  }, [fileStore])

  const renderPendingUploads = () => {
    const cancelUpload = (uploadFile: UploadFile) => {
      const cancel = cancelFunctions.get(uploadFile.id)

      if (cancel) {
        fileStore.cancelPendingUpload(uploadFile)
        cancel()
      }
    }

    return fileStore.unfinishedUploads
      .slice()
      .sort((a: UploadFile, b: UploadFile) =>
        a.name + a.id > b.name + b.id ? 1 : 0,
      )
      .map((uploadFile: UploadFile) => {
        return (
          <Card key={uploadFile.id}>
            <Card.Content>
              <Card.Header>
                <Progress
                  percent={uploadFile.progress}
                  indicating
                  progress
                  warning
                />
              </Card.Header>
              <Card.Meta>
                {t('uploadingFiles')} ... ({filesize(uploadFile.size)})
                <br />
                Started <TimeAgo date={uploadFile.uploadStarted} />
              </Card.Meta>
              <Card.Description>
                <Popup
                  position="left center"
                  content="cancel"
                  trigger={
                    <Button
                      icon
                      floated="right"
                      size="mini"
                      onClick={() => cancelUpload(uploadFile)}
                    >
                      <Icon name="close" />
                    </Button>
                  }
                />
                <TruncateString text={uploadFile.name} />
              </Card.Description>
            </Card.Content>
          </Card>
        )
      })
  }

  const renderUploadButton = () => {
    const uploading = !!fileStore.unfinishedUploads.length
    return (
      <Files
        maxSize="5gb"
        onSuccess={async ([selectedFile]: any) => {
          fileStore.handleUpload(selectedFile)
        }}
        onError={(error: any) => {
          console.error(error)
        }}
      >
        {({ browseFiles }: any) => (
          <div className="main-button-cont">
            <Popup
              position="top center"
              content={
                <>
                  <Icon name="lightbulb outline" /> {t('uploadDragTips')}
                </>
              }
              trigger={
                <Button size="big" onClick={browseFiles} color="yellow">
                  {uploading ? (
                    <Icon loading name="spinner" />
                  ) : (
                    <Icon name="cloud upload" />
                  )}
                  {uploading ? t('uploadingFiles') : t('uploadFiles')}
                </Button>
              }
            />
            {/* TODO: this is shit placement */}
            <NewFolder />
          </div>
        )}
      </Files>
    )
  }

  const FileDropZone = () => {
    const onDrop = useCallback((acceptedFiles) => {
      const pendingUploads: UploadFile[] = acceptedFiles.map((file: File) => {
        const { name, size, type } = file
        return {
          id: 'file' + Math.round(Math.random() * 1000),
          name,
          size,
          src: { file },
          type,
          progress: 0,
          uploadStarted: new Date(),
        }
      })
      fileStore.queueFiles(pendingUploads)
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
    })

    return (
      <div
        {...getRootProps()}
        className={
          isDragActive ? 'file-drop-zone drop-zone-active' : 'file-drop-zone'
        }
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <h4 className="drop-zone-text">Drop them now!</h4>
        ) : (
          <h4 className="drop-zone-text">Drag & Drop Files or Folders here</h4>
        )}
      </div>
    )
  }

  const { showDropZone } = uiStore
  return (
    <>
      {renderUploadButton()}
      <br />
      {!!showDropZone && <FileDropZone />}
      <br />
      <Card.Group>
        {renderPendingUploads()}
        {!!fileStore.queuedUploads.length && (
          <Card>
            <Card.Content>
              <Card.Description>
                <Statistic horizontal>
                  <Statistic.Value>
                    +{fileStore.queuedUploads.length}
                  </Statistic.Value>
                  <Statistic.Label>Pending</Statistic.Label>
                </Statistic>
              </Card.Description>
            </Card.Content>
          </Card>
        )}
      </Card.Group>
    </>
  )
})

export default Uploads
